import { Card, Col, Row } from "reactstrap";
import CommonTable from "../Common/CommonTable";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { StripedRowWithInverseTables } from "../../../../Constant";
import { STRIPED_ROW, STRIPED_ROW_BODY, STRIPED_ROW_HEAD } from "../../../../Data/BootstrapTable/BasicTable";

export const StripedRowInverseTable = () => {
  return (
    <Col sm="6">
      <Card>
        <CommonCardHeader title={StripedRowWithInverseTables} span={STRIPED_ROW} table/>
        <Row className="card-block">
          <Col sm="12" lg="12" xl="12">
            <CommonTable strip tableClass="table-inverse" headData={STRIPED_ROW_HEAD}>
              {STRIPED_ROW_BODY.map((data) => (
                <tr key={data.id}>
                  <th scope="row">{data.id}</th>
                  <td>{data.dessert}</td>
                  <td>{data.calories}</td>
                  <td>{data.fat}</td>
                  <td>{data.price}</td>
                </tr>
              ))}
            </CommonTable>
          </Col>
        </Row>
      </Card>
    </Col>
  );
};
